import React from 'react';
import { Container } from '../Container';
import { Section } from '../Section';
import { Reveal } from '../Reveal';
import { AppImage } from '../AppImage';
import { principles } from '../../data/about';
import { principleImages } from '../../data/homeImages';
const featuredPrinciples = principles.slice(0, 3);
export function TestimonialSection() {
  return <Section labelledBy="how-we-work-title" className="bg-ink text-white" data-id="element-616" data-mp="36bu9gl3wuwlc">
      <Container data-id="element-617" data-mp="2iovx9zmtqat8">
        <Reveal data-id="element-618" data-mp="2im9s26neo7e6">
          <h2 id="how-we-work-title" className="max-w-[16ch] text-[40px] leading-[1.05] tracking-[-0.03em] text-white lg:text-[56px]" data-id="element-619" data-mp="2dp9lzvqk34n2">
            How we work.
          </h2>
          <p className="mt-6 max-w-[52ch] text-body text-white/60" data-id="element-620" data-mp="2mq7ryjkk1m8a">
            Three of the positions that decide what we take on and how a project runs. The rest are
            on the about page.
          </p>
        </Reveal>

        <ul className="mt-14 grid gap-6 lg:mt-16 lg:grid-cols-3" data-id="element-621" data-mp="1uxqkxug3e0no">
          {featuredPrinciples.map((principle, index) => <Reveal as="li" key={principle.title} delay={index * 0.06} className="h-full" data-id="element-622" data-mp="9pdot0or6cnt" data-mpi={index}>
              <div className="flex h-full flex-col rounded-card border border-white/15 p-8" data-id="element-623" data-mp="en5seryrfn7u">
                <AppImage src={principleImages[index].image} alt={principleImages[index].alt} ratio="1:1" borderClass="border-white/15" data-id="element-624" data-mp="jfyvzcihspic" />
                <p className="mt-8 text-[13px] tabular-nums text-white/50" data-id="element-625" data-mp="3mya3y22pxnrx">
                  {String(index + 1).padStart(2, '0')}
                </p>
                <h3 className="mt-4 max-w-[18ch] text-[24px] leading-[1.25] tracking-[-0.025em] text-white" data-id="element-626" data-mp="opi6r1oveky">
                  {principle.title}
                </h3>
                <p className="mt-4 text-small leading-6 text-white/60" data-id="element-627" data-mp="1c44gpz9jqei6">{principle.description}</p>
              </div>
            </Reveal>)}
        </ul>
      </Container>
    </Section>;
}